"use client";

import { useVisibleNavLinks } from "@/hooks/useVisibleNavLinks";
import Link from "next/link";

export default function QuickLinks({ locale }: { locale: string }) {
  const isAr = locale === "ar";
  const navLinks = useVisibleNavLinks();

  return (
    <div className="lg:col-span-3">
      <h4 className="text-brand-creamy font-bold mb-6 tracking-wide">
        {isAr ? "روابط سريعة" : "Quick Links"}
      </h4>
      <ul className="grid grid-cols-1 gap-3 text-sm text-white/70">
        {navLinks.map((link) => (
          <li key={link.to}>
            <Link href={link.to} className="hover:text-brand-red transition">
              {isAr ? link.label_ar : link.label_en}
            </Link>
          </li>
        ))}
        <li>
          <Link
            href={`/${locale}/support`}
            className="hover:text-brand-red transition flex items-center gap-1.5"
          >
            {isAr ? "خدمة العملاء" : "Customer Support"}
          </Link>
        </li>
      </ul>
    </div>
  );
}
